var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _line, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefrigerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.1,515.5c-.1,0-.2.2-.3.3.1,0,.2-.2.3-.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.7,515.9c-.2,0-.3.2-.5.3.2,0,.3-.2.5-.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.5,515.1c0,0-.1.1-.2.2,0,0,.1-.1.2-.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.7,516.4c-.3,0-.5,0-.7,0,.2,0,.5,0,.7,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.1,516.1c-.2,0-.4.1-.6.2.2,0,.4-.1.6-.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.4,516.1s0,0,0,0c0,0,0,0,0,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.9,514.7s0,0,0,.1c0,0,0,0,0-.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.4,512.7c0,.3,0,.5,0,.7,0-.2,0-.5,0-.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.7,83.7h0,104.8v273.2h0V83.6h-104.8c-2.1,0-3.7,1.7-3.7,3.7h0c0-2,1.7-3.6,3.7-3.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.5,136.5c-1.5,0-2.7,1.2-2.7,2.7,0-1.5,1.2-2.7,2.7-2.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.3,360.6h0V87.3c0-.7.1-1.3.3-1.9-.2.6-.3,1.2-.3,1.9v273.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.1,514.1s0,0,0,0c0,0,0,0,0,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8,515.9s0,0-.1,0c0,0,0,0,.1,0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.3,514.1c0-.2-.1-.4-.2-.6,0,.2.1.4.2.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M424.7,83.7h-104.8v273.2h0c0,0,108.4,0,108.4,0V87.3c0-2.1-1.7-3.7-3.7-3.7ZM337.3,307.8c0,3.5-2.9,6.4-6.4,6.4s-6.4-2.9-6.4-6.4v-168.5c0-3.5,2.9-6.4,6.4-6.4h0c3.5,0,6.4,2.8,6.4,6.3v168.6Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.9,136.5c-1.5,0-2.7,1.2-2.7,2.7v168.6c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7h0v-168.6c0-1.5-1.2-2.7-2.7-2.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.3,515.5c0,0-.1-.1-.2-.2,0,0,.1.1.2.2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.4,379.7c0,1.5-1.2,2.7-2.7,2.7h0c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7h0c1.5,0,2.7,1.2,2.7,2.7Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.9,515.1c0-.1-.2-.2-.3-.3,0,.1.2.2.3.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.6,514.7c0-.2-.2-.3-.3-.5,0,.2.2.3.3.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411,379.7c0,3.5-2.9,6.4-6.4,6.4h0c3.5,0,6.4-2.9,6.4-6.4s-2.9-6.4-6.4-6.4h0c3.5,0,6.4,2.9,6.4,6.4Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.1,516.3h29.2c-.6-1.1-1-2.3-1-3.7v-152.1h0V87.3c0-.7,0-1.3.3-1.9l-29.3,6.1c-1.7.4-2.9,1.9-2.9,3.6v417.6c0,2.1,1.7,3.7,3.7,3.7Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.5,310.4c1.5,0,2.7-1.2,2.7-2.7v-168.5c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7v168.5c0,1.5,1.2,2.7,2.7,2.7Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 210.6,
    y1: 83.7,
    x2: 210.7,
    y2: 83.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M315.4,83.7h-104.7c-2,0-3.7,1.6-3.7,3.7v269.6h108.4V83.7ZM310.9,307.7h0c0,3.6-2.9,6.5-6.4,6.5h0c-3.5,0-6.4-2.9-6.4-6.5v-168.5c0-3.5,2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4v168.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M424.7,80h-214.1c-1.3,0-2.5.4-3.5,1l-33.4,7c-3.4.7-5.8,3.7-5.8,7.1v417.7c0,4,3.3,7.3,7.3,7.3h249.6c4,0,7.3-3.3,7.3-7.3V87.3c0-4-3.3-7.3-7.3-7.3ZM207,87.3h0c0-2.1,1.6-3.7,3.7-3.7h104.8v273.3h-108.5V87.3ZM171.4,95c0-1.7,1.2-3.2,2.9-3.6l29.3-6.1c-.1.6-.3,1.2-.3,1.9v425.4c0,1.3.4,2.6,1,3.7h-29.2c-2,0-3.7-1.6-3.7-3.7V95ZM428.4,512.7c0,.2,0,.5,0,.7,0,.2-.1.4-.2.6,0,0,0,0,0,0,0,.2-.2.3-.3.5,0,0,0,0,0,.1,0,.1-.2.2-.3.3,0,0-.1.1-.2.2,0,0-.1.1-.2.2-.1,0-.2.2-.3.3,0,0,0,0-.1,0-.2.1-.3.2-.5.3,0,0,0,0,0,0-.2,0-.4.1-.6.2-.2,0-.5,0-.7,0h-214.1c-.2,0-.5,0-.7,0-.2,0-.4-.1-.6-.2,0,0,0,0,0,0-.2,0-.3-.2-.5-.3,0,0,0,0-.1,0-.1,0-.2-.2-.3-.3,0,0-.1-.1-.2-.2,0,0-.1-.1-.2-.2,0-.1-.2-.2-.3-.3,0,0,0,0,0-.1-.1-.2-.2-.3-.3-.5,0,0,0,0,0,0,0-.2-.1-.4-.2-.6,0-.2,0-.5,0-.7v-152.2h221.4v152.2ZM428.4,357h-108.5V83.7h104.8c2,0,3.7,1.6,3.7,3.7v269.6Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M330.9,132.8h0c-3.5,0-6.4,2.9-6.4,6.5v168.5c0,3.5,2.9,6.4,6.4,6.4s6.4-2.9,6.4-6.4v-168.6c0-3.5-2.9-6.4-6.4-6.4ZM333.7,307.7h0c0,1.6-1.2,2.8-2.7,2.8s-2.7-1.2-2.7-2.7v-168.6c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v168.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M304.5,132.8c-3.5,0-6.4,2.9-6.4,6.4v168.5c0,3.5,2.9,6.4,6.4,6.4h0c3.5,0,6.4-2.8,6.4-6.3h0v-168.6c0-3.5-2.9-6.4-6.4-6.4ZM301.8,139.2c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v168.5c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7v-168.5Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M315.4,360.6h-108.4v152.2c0,.2,0,.5,0,.7,0,.2.1.4.2.6,0,0,0,0,0,0,0,.2.2.3.3.5,0,0,0,0,0,.1,0,.1.2.2.3.3,0,0,.1.1.2.2,0,0,.1.1.2.2.1,0,.2.2.3.3,0,0,0,0,.1,0,.2.1.3.2.5.3,0,0,0,0,0,0,.2,0,.4.1.6.2.2,0,.5,0,.7,0h214.1c.2,0,.5,0,.7,0,.2,0,.4-.1.6-.2,0,0,0,0,0,0,.2,0,.3-.2.5-.3,0,0,0,0,.1,0,.1,0,.2-.2.3-.3,0,0,.1-.1.2-.2,0,0,.1-.1.2-.2,0-.1.2-.2.3-.3,0,0,0,0,0-.1.1-.2.2-.3.3-.5,0,0,0,0,0,0,0-.2.1-.4.2-.6,0-.2,0-.5,0-.7v-152.2h-113ZM404.7,373.3c3.5,0,6.4,2.9,6.4,6.4s-2.9,6.4-6.4,6.4h-173.1c-3.5,0-6.4-2.9-6.4-6.4h0c0-3.5,2.9-6.4,6.4-6.4h173.1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.9,379.7c0,1.5,1.2,2.7,2.7,2.7h173c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7h-173c-1.5,0-2.7,1.2-2.7,2.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M231.6,373.3c-3.5,0-6.4,2.9-6.4,6.4h0c0,3.5,2.9,6.4,6.4,6.4h173.1c3.5,0,6.4-2.9,6.4-6.4s-2.9-6.4-6.4-6.4h-173.1ZM404.6,377h0c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7h-173.1c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7h173Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigerator);
export default __webpack_public_path__ + "static/media/refrigerator.04c54a0d3ef38d204401ef4e49c335ac.svg";
export { ForwardRef as ReactComponent };